import { Flex, Heading, Spinner, Text } from "@radix-ui/themes";
import { FC } from "react";
import { usePrecisionGameLeaderboard } from "../hooks/usePrecisionGameLeaderboard";
import { ErrorFallback } from "@/components";
import { PrecisionGameUIProps } from "../models/precisionGame.types";
import i18next from "i18next";

const PrecisionGameUIMentions: FC<PrecisionGameUIProps> = ({
  collection,
  orientation = "horizontal",
  headline = i18next.t("precisionGame.honorable.headline"),
}): JSX.Element => {
  const { mentions, loading, error } = usePrecisionGameLeaderboard(collection);
  const isVertical = orientation === "vertical";

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return <ErrorFallback>{error.message}</ErrorFallback>;
  }

  if (mentions && mentions.length > 0) {
    const mentionsList = isVertical ? mentions.slice(0, 100) : mentions;

    const totalMentions = mentions.length;
    const mentionsCount = totalMentions - 100;

    return (
      <Flex direction="column" gap="3">
        <Heading as="h2" size="5">
          {headline}
        </Heading>
        <Flex wrap="wrap" gap="1">
          {mentionsList.map((record, index) => {
            const key = `mention-${index}`;

            return (
              <Text size="2" color="gray" key={key}>
                {record.userName} <Text size="1">({record.score})</Text>
              </Text>
            );
          })}
          {totalMentions > 80 && mentionsCount > 0 && (
            <Text size="2" color="gray">
              +{mentionsCount} more...
            </Text>
          )}
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex direction="column" gap="3">
      <Heading as="h2" size="5">
        {headline}
      </Heading>
      <Text size="2" color="gray">
        {i18next.t("precisionGame.honorable.none")}
      </Text>
    </Flex>
  );
};

export default PrecisionGameUIMentions;
